import { render } from "./AdminPicker.vue?vue&type=template&id=3669c788"
import script from "./AdminPicker.vue?vue&type=script&lang=js"
export * from "./AdminPicker.vue?vue&type=script&lang=js"

import "./AdminPicker.vue?vue&type=style&index=0&id=3669c788&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__